export default {
  wallet: {
    title: 'Cartera',
    balance: 'Saldo',
    deposit: 'Depósito',
    withdraw: 'Retirar',
    rollover: 'Rollover',
    transaction: 'Transacción',
    myBet: 'Mis Apuestas',
    totalBalance: 'Saldo Total',
    withdrawableBalance: 'Saldo Retirable',
    bonus: 'Bono',
    bonusBalance: 'Saldo de Bono',
    cashBalance: 'Saldo en Efectivo',
    withdrawable: 'Retirable',
    depositNow: 'Depositar Ahora',
    getBonus: 'Obtener Bono',
    bonusGames: 'Juegos con Bono',
    playNow: 'Jugar Ahora',
    fiatAccount: 'Cuenta Fiat',
    cash: 'Efectivo',
    rules: 'Reglas',
    ruleQ1: '1. ¿Qué es el Bono?',
    ruleA1: 'Los bonos son recompensas otorgadas por la plataforma tras participar en actividades y pueden usarse para apostar en juegos con bono designados.',
    ruleQ2: '2. ¿Cómo puedo usar el bono?',
    ruleA2: 'El bono solo puede usarse para apostar después de agotar el saldo de la cartera de efectivo. El bono debe cumplir el requisito de apuesta antes de poder convertirse a la cartera de efectivo.',
    ruleQ3: '3. ¿Qué juegos admiten apuestas con bono?',
    ruleA3: 'La mayoría de los juegos de tragaperras admiten apuestas con bono. Para ver la lista detallada de juegos, consulta la página de Juegos con Bono.',
    ruleQ4: '4. ¿Hay restricciones para convertir el bono a la cartera de efectivo?',
    ruleA4: 'Una vez cumplidos los requisitos de apuesta del bono, puedes convertir el bono original a la cartera de efectivo en el Centro de Recompensas. Cualquier ganancia de bono restante se devolverá a la Cartera de Bono y los requisitos de apuesta se recalcularán.',
    ruleQ5: '5. ¿Hay restricciones para convertir la ganancia del bono a la cartera de efectivo?',
    ruleA5: 'La ganancia del bono debe cumplir un requisito de apuesta de 15x. La ganancia máxima de bono que puede convertirse a la cartera de efectivo es USDT5.000,00 y el importe máximo por apuesta es USDT1.000,00.',
    ruleQ6: '6. ¿Cómo se calcula el requisito de apuesta?',
    ruleA6: 'Juegos de tragaperras: Importe apostado = Requisito de apuesta. Otros juegos: Importe apostado = Valor absoluto de la ganancia (hasta el importe de la apuesta)',
    select: 'Seleccionar',
    currency: 'Moneda',
    loading: 'Cargando...',
    noMoreData: 'No hay más datos',
    noData: 'Sin datos',
    colType: 'Tipo',
    colTime: 'Hora',
    colStatus: 'Estado',
    colAmount: 'Importe',
    colBalance: 'Saldo',
    allType: 'Todos los Tipos',
    allStats: 'Todos los Estados',
    colWallet: 'Cartera',
    colCurrent: 'Actual',
    colRequired: 'Requerido',
    colStats: 'Estado',
    totalVaultBalance: 'Saldo Total de la Cámara',
    amount: 'Importe',
    availableBalance: 'Saldo Disponible:',
    max: 'MÁX',
    depositInVault: 'Depositar en la Cámara',
    depositCurrency: 'Moneda de Depósito',
    currencyBalance: 'Saldo por Moneda',
    history: 'Historial',
    vaultRules: 'Reglas de la Cámara',
    vaultRule1: 'La Cámara es un lugar seguro para guardar fondos sin preocuparse por comisiones de transacción o retrasos en la blockchain. La Cámara funciona como tu propia cartera digital o incluso como una cuenta de ahorros bancaria. Es extremadamente segura – gracias a 2FA – y puedes aplicar medidas de seguridad reforzadas para cuidar los fondos que contiene.',
    vaultRule2: 'El depósito y la retirada de fondos en la Cámara están protegidos por 2FA y el depositante puede acceder a ellos en cualquier momento.',
    vaultRule3: '¡Los fondos en la Cámara no serán tocados por nadie salvo el depositante. Son tuyos y siempre estarán seguros para que los uses!',
    selectTime: 'Seleccionar Hora',
    colGame: 'Juego',
    colBet: 'Apuesta',
    colWin: 'Ganancia',
    colProfit: 'Beneficio',
    sports: 'Deportes',
    allGames: 'Todos los juegos',
    today: 'Hoy',
    yesterday: 'Ayer',
    last3Days: 'Últimos 3 días',
    last7Days: 'Últimos 7 días',
    last15Days: 'Últimos 15 días',
    last30Days: 'Últimos 30 días',
  },
};
